import { reactive } from 'vue'
import { loginCommonConfig } from './common'
import type { LoginPageConfig } from './types'

export const theme = {
  facebookBlue: '#1A77F2',
  googleBlue: '#239FFB',
  appleDark: '#282828',
  inputBorder: 'rgba(255, 255, 255, 0.15)',
} as const

export const resources = {
  loginBg: '/images/flipnovel/login/login-bg.webp',
  logo: '/images/flipnovel/login/flipnovel-logo.svg',
  novel: '/images/flipnovel/login/flipnovel-novel.svg',
  facebookIcon: '/images/flipnovel/login/icon-facebook-logo.png',
  googleIcon: '/images/flipnovel/login/icon-google-logo-flipnovel.svg',
  appleIcon: '/images/flipnovel/login/icon-apple-logo-flipnovel.svg',
  emailIcon: '/images/flipnovel/login/icon-email.png',
  emailCodeIcon: '/images/flipnovel/login/icon-email-code.png',
} as const

export const loginConfig: LoginPageConfig = {
  theme,
  resources,
  texts: reactive(loginCommonConfig.texts),
}
